export default __webpack_public_path__ + "static/5-95343521f86da17a33e1515c69ca935b.png";